export function isNull<T>(arg: T): boolean {
  return arg === null;
}
